<p-toast position="top-center" styleClass="!mt-[5rem]" [baseZIndex]="200000" />
<main class="auth-layout-shell relative isolate min-h-screen overflow-hidden bg-gray-100 dark:bg-surface-950">
    <div class="auth-layout-shell__content relative z-[1] min-h-screen">
        <router-outlet />
    </div>
</main>
